<template>
  <div class="bg auth-screen">
    <div class="container pt-120">
      <div class="card" v-if="!resetLinkSent">
        <div class="card-body">
          <h2 class="card-title">Forgot Password</h2>
          <div v-if="!resetPasswordSSOError">
            <div class="card-description">Provide your username and we will send you a verification code to reset your password.</div>
            <form>
              <div class="form-group">
                <label>Username</label>
                <router-link :to="{ name: 'dont-have-username' }" class="create-username">Don’t have a username?</router-link>
                <input type="text" v-validate="'required|min:8'" name="username" :class="{ input: true, 'is-danger': errors.has('username'), 'is-success': !errors.has('username') }" class="form-control form-control-lg" v-model="user.username" placeholder="Enter your username" required />
                <span v-show="errors.has('username')" class="text-danger">{{ errors.first("username") }}</span>
              </div>
              <p class="text-danger" v-if="errorMsg">{{ errorMsg }}</p>
              <div class="form-group">
                <button type="submit" class="btn btn-primary btn-block" :disabled="errors.any() || !isCompleted || apiCallInProgress" v-on:click.prevent="checkUsername">Submit</button>
              </div>
            </form>
            <div class="footer-links">
              <router-link :to="{ name: 'login' }">Back to sign in</router-link>
            </div>
          </div>
          <div v-else class="text-center">
            <div class="heading">Single Sign-On has been configured for this username.</div>
            <div class="mt-26">Please contact THREAD Support for further assistance in resetting your password.</div>
            <p class="text-danger" v-if="errorMsg">{{ errorMsg }}</p>
            <div class="form-group mt-24">
              <router-link :to="{ name: 'login' }" tag="button" class="btn btn-primary btn-block">OK</router-link>
            </div>
          </div>
        </div>
      </div>
      <div class="card" v-else>
        <div class="card-body">
          <h2 class="card-title">Check your email</h2>
          <div class="card-description">
            We've sent you a password reset link.<br />
            See you back here soon!
          </div>
          <div>
            <router-link :to="{ name: 'login' }" tag="button" class="btn btn-primary btn-block">Sign in</router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { Auth } from "aws-amplify";
import nprogress from "nprogress";
import "nprogress/nprogress.css";
import localStorageService from "@/services/localStorage";
export default {
  name: "forgotPassword",
  data() {
    return {
      user: {
        username: ""
      },
      formErrors: false,
      resetLinkSent: false,
      errorMsg: null,
      apiCallInProgress: false,
      resetPasswordSSOError: false
    };
  },
  watch: {
    user: {
      handler(v) {
        this.errorMsg = null;
      },
      deep: true
    }
  },
  computed: {
    isCompleted() {
      return this.user.username != "";
    }
  },
  mounted() {
    this.userLogout();
  },
  methods: {
    ...mapActions(["userLogout"]),
    async requestResetPasswordCode() {
      this.apiCallInProgress = true;
      nprogress.start();
      try {
        const clientId = localStorageService.getItem("clientId");
        await Auth.forgotPassword(this.user.username.toLowerCase(), { userType: "portal", requestFor: "FORGOT_PASSWORD", clientId: clientId });
        this.$toastr.success("We’ve sent a six-digit confirmation code to your email address on file. Enter it on the next screen.");
        nprogress.done();
        setTimeout(() => {
          this.$router.push({
            name: "create-password-aws",
            params: {
              username: this.user.username.toLowerCase()
            }
          });
        }, 5000);
      } catch (error) {
        nprogress.done();
        this.apiCallInProgress = false;
        if (error.code && error.code == "UserNotFoundException") {
          this.errorMsg = "Username not found.";
        } else {
          let errMsg = error.message.split("###");
          this.errorMsg = errMsg.length > 1 ? errMsg[2].trim() : errMsg[0];
        }
      }
    },
    checkUsername() {
      this.apiCallInProgress = true;
      nprogress.start();
      this.$api
        .checkUsernameAvailability({
          username: this.user.username.toLowerCase()
        })
        .then(
          response => {
            this.apiCallInProgress = false;
            nprogress.done();
            if (response.body.errorMessage && response.body.errorMessage == "USERNAME_EXISTS") {
              this.checkIfSSOEnabledForUser();
            } else {
              this.errorMsg = "Username not found.";
            }
          },
          error => {
            this.apiCallInProgress = false;
            nprogress.done();
            this.errorMsg = error.body && error.body.message ? error.body.message : "Error while validating username.";
          }
        );
    },
    checkIfSSOEnabledForUser() {
      this.apiCallInProgress = true;
      nprogress.start();
      this.$api
        .checkIfSSOEnabledForUser({
          userName: this.user.username
        })
        .then(
          response => {
            this.apiCallInProgress = false;
            nprogress.done();
            if (response.body.data && response.body.data.ssoEnabled && response.body.data.ssoEnabled == 1) {
              this.resetPasswordSSOError = true;
            } else {
              this.requestResetPasswordCode();
            }
          },
          error => {
            this.apiCallInProgress = false;
            nprogress.done();
            this.errorMsg = error.body && error.body.message ? error.body.message : "Error while validating username.";
          }
        );
    }
  }
};
</script>

<style scoped lang="scss" src="@/assets/auth-screen.scss"></style>
